import { getToken } from "@/utils/auth";
// import Service from '../../../env/index'

const clientCode = 'customer_account'
// const user = JSON.parse(localStorage.getItem('vuex') || '{}')?.user || {}

export const IFRAME_DATA = {
  // apps: APPS,
  appToken: getToken(),
  clientCode: 'customer_account',
  type: 'application',
  // appUserId: user.userId,
};

// const isProd = process.env.NODE_ENV === 'production'
export function getData(user, token, customers) {
  const {
    creditCode,
    tenantId,
    userId,
    customerCode,
    customerId,
    accountId,
    tenantName,
    customerName,
    mobile,
    accountName,
  } = user
  return {
    appToken: token,
    creditCode,
    accountType: 'CUSTOMER',
    groupId: 'SYSTEM_APP_ID_CUSTOMER_WEB',
    accountTypeName: '货主',
    token,
    userId,
    tenantId,
    tenantName,
    customerName,
    appClientCode: clientCode,
    appTenantId: tenantId,
    appId: clientCode,
    customerCode,
    customers,
    mobile,
    customerId,
    identityName: customerName || accountName,
    type: 'application',
    identityId: customerId,
    account: user.realName,
    accountId,
    appKeys: ['appcenter.consignor']
  }
}
